import api from 'api';

export const loadApplications = api('GET /api/regs-stats/filters/applications');

export const loadNetworks = api('GET /api/regs-stats/filters/networks');

export const loadPlatforms = api('GET /api/regs-stats/filters/platforms');

export const loadAffiliates = api('GET /api/regs-stats/filters/affiliates');

export const loadRealCountries = api(
  'GET /api/regs-stats/filters/real-countries'
);
